import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToTrue, updateCounter} from '../../../../store/actions/main';
import {updateProductToMerklisteGelaender,
        updateStepsGelaender,
        selectUploadDataGelaender,
        updateDescriptionGelaender,
        updateAllVisitedStepsGelaender
        } from '../../../../store/actions/gelaender';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router-dom';
import LaunchIcon from '@material-ui/icons/Launch';
import TextField from '@material-ui/core/TextField';
import DescriptionIcon from '@material-ui/icons/Description';
//import {PrintAngebot} from '../../../../module/printAngebot';

const Step_7 = (props) => {

  const [is_upload_data, updateUploadData] = useState('');
  const [validFile, updateValidFile] = useState(true);
  const [mbytes, updateMbytes] = useState(0);
  const [fileName, updateFileName] = useState('');
  const [descriptionData, updateDescriptionData] = useState('');
  let [is_merkliste, isMerklisteUpdate] = useState(false);
  let empty_file = '';
  // let [printMainTitel, setPrintMainTitel] = useState('');
  // let [printMuster, setPrintMuster] = useState('');
  // let [isMuster, setIsMuster] = useState(false);
  // let [printDimensions, setPrintDimensions] = useState('');
  // let [printColors, setPrintColors] = useState('');
  // let [printPfosten, setPrintPfosten] = useState('');
  // let [printPrice, setPrintPrice] = useState(0);
  // let [printLayout, setPrintLayout] = useState('');
  // let [printBefestigungsart, setPrintBefestigungsart] = useState('');
  // let [printProduct, setPrintProduct] = useState('');
  // let [printGlasart, setPrintGlasart] = useState('');
  // let [printFormHandrail, setPrintFormHandrail] = useState('');

    useEffect(() => {
      updateItems();
    })

   const updateItems = () => {
      let step = 6;
      let is_merkliste = props.data[props.modell_type].is_merkliste;
      const {isUploadData, description, file} = props.data[props.modell_type].data_description[0];
      let data_upload_button = document.querySelector('.data_upload_button');
      let addButtonMerkliste = document.querySelector('.addButtonMerkliste');
      let toWishListButton = document.querySelector('.toWishListButton');

      if (file) {
        updateFileName(file.name);
        const bytesToMegaBytes = file.size / (1024 ** 2);
        updateMbytes(bytesToMegaBytes);
      }

      if (isUploadData) {
        data_upload_button.classList.add('check');
      } else {
        data_upload_button.classList.remove('check');
      }

      updateUploadData(isUploadData);
      updateDescriptionData(description);
      isMerklisteUpdate(is_merkliste);


      if(is_merkliste) {
        addButtonMerkliste.classList.add('check');
        toWishListButton.classList.add('check');
      } else {
        toWishListButton.classList.remove('check');
        addButtonMerkliste.classList.remove('check');
      }

      //update steps
      if (props.modell_type === 3) step = 5;
      if (props.modell_type === 1) step = 6;
      if (props.modell_type === 0 || props.modell_type === 2) step = 7;

      props.updateSteps(step);

      props.setUpdateButtonActiveStepToTrue();
      props.updateAllVisitedSteps();
      //printItems();
   }

  //  const printItems = () => {
  //       let mainTitel = props.data[props.modell_type].modell[0].muster === 'Sortiment'&&props.data[props.modell_type].modell[0].titel?props.data[props.modell_type].modell[0].titel:'Eigenes Muster';
  //       if (mainTitel === 'Eigenes Muster') setIsMuster(false);
  //       else setIsMuster(true);
  //       let product = props.data[props.modell_type].modell[0].kind;
  //       let muster = props.data[props.modell_type].modell[0].img;
  //       let dimensions = props.data[props.modell_type].dimensions[0];
  //       let colors = props.data[props.modell_type].colors[0]?props.data[props.modell_type].colors[0]:'';
  //       let pfosten = props.data[props.modell_type].pfosten_form;
  //       let price = props.data[props.modell_type].modell[0].price;
  //       let layout = props.data[props.modell_type].layout;
  //       let befestigungsart = props.data[props.modell_type].befestigungsart;
  //       let glasart = props.data[props.modell_type].glasart;
  //       let handrail = props.data[props.modell_type].form_handrail[0];

  //       setPrintMainTitel(mainTitel);
  //       setPrintMuster(muster);
  //       setPrintDimensions(dimensions);
  //       setPrintColors(colors);
  //       setPrintPfosten(pfosten);
  //       setPrintPrice(price);
  //       setPrintProduct(product);
  //       setPrintLayout(layout);
  //       setPrintBefestigungsart(befestigungsart);
  //       setPrintGlasart(glasart);
  //       setPrintFormHandrail(handrail);
  //  }

const selectUploadData = ev => {
    ev.preventDefault();
    let file = ev.target.files[0];
    console.log('FILE', file);

    const fileSize = file.size;
    const bytesToMegaBytes = fileSize / (1024 ** 2);

    if (bytesToMegaBytes > 5) {
        updateValidFile(false);
    } else {
        updateValidFile(true);
        updateMbytes(bytesToMegaBytes);
        updateFileName(file.name);
    }

    let uploadObject = {file: file}

    props.selectUploadData(uploadObject);
    updateItems();

}

const updateDescription = ev => {
    let description = ev.target.value;
    props.updateDescription(description);
    updateItems();
}

const updateProductToMerkliste = () => {
     props.updateProductToMerkliste();
     updateItems();
    if(is_merkliste)  props.updateCounter('dec');
    else  props.updateCounter('inc');
}

   return (
    <div className="step_wrapper">
      <h2 className='step_header'>Hier können Sie uns Ihr Anliegen mit einer detalierten Beschreibung und ggf. einer Skizze mitteilen.</h2>
      <div className="step_icon_wrapper">
          <TextField
              className="outlined-multiline-static textfield_multiline"
              type="text"
              label="Ihr Anliegen:"
              rowsMax={10}
              multiline
              variant="outlined"
              value={descriptionData}
              name="description"
              onChange={updateDescription}
              >
          </TextField>
          <div className="merkliste_button_wrapper">
              <Button  className='data_upload_button' component="label" startIcon={<DescriptionIcon />}>
                  {is_upload_data?
                  <span>Datei ausgewählt<br/>({fileName.substring(0, 14)+'...'} {mbytes.toFixed(2)} MB)</span>
                  :
                  <span>Datei auswählen<br/>(max 5MB)</span>
                  }
                  <input id='myfileinput' name='productimage' className='upload_file_zaun' type="file" onChange={selectUploadData} value={empty_file} hidden />
              </Button>
              {!validFile && <span style={{color:'red', margin:'10px 0'}}>Ihre Datei ist zu groß für das Zieldateisystem</span>}
              {/* <PrintAngebot
                  product={printProduct}
                  mainTitel={printMainTitel}
                  muster={printMuster}
                  isMuster={isMuster}
                  dimensions={printDimensions}
                  colors={printColors}
                  pfosten={printPfosten}
                  layout={printLayout}
                  price={printPrice}
                  befestigungsart={printBefestigungsart}
                  glasart={printGlasart}
                  form_handrail={printFormHandrail}
                  className='print_button'
              /> */}
              <Button className='addButtonMerkliste' onClick={updateProductToMerkliste}>{is_merkliste?'aus der Merkliste entfernen':'in die Merkliste hinzufügen'}</Button>
              <Link className="link" to={is_merkliste?'/merkliste':'#'}><Button className='toWishListButton'>Zur Merkliste <LaunchIcon className='launch-icon' /></Button></Link>
          </div>

      </div>
</div>
   )
}

const mapStateToProps = state => {
    return {
        modell_type: state.gelaenderReducer.modell_type,
        data: state.gelaenderReducer.data

    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateProductToMerkliste: () => dispatch(updateProductToMerklisteGelaender()),
      updateCounter: ev => dispatch(updateCounter(ev)),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      selectUploadData: ev => dispatch(selectUploadDataGelaender(ev)),
      updateDescription: ev => dispatch(updateDescriptionGelaender(ev)),
      updateAllVisitedSteps: () => dispatch(updateAllVisitedStepsGelaender())
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_7);
